import React, { useRef } from 'react';
import Draggable from 'react-draggable';
import PropTypes from 'prop-types';
import ReactHtmlParser from 'react-html-parser';

import {
  CloseButton,
  StyledCloseIcon,
  StyledPopper,
  InstructionsContainer,
  InstructionsContent,
  Title,
  Text,
} from './styles';
import texts from './texts';

const HANDLE_ID = 'workout-instructions-handle';

const WorkoutGenInstructions = ({ isOpen, onClose }) => {
  const draggableRef = useRef(null);

  return (
    <Draggable nodeRef={draggableRef} handle={`#${HANDLE_ID}`}>
      <StyledPopper
        sx={{ zIndex: 1300 }}
        open={isOpen}
        onClose={onClose}
        ref={draggableRef}
      >
        <CloseButton onClick={onClose}>
          <StyledCloseIcon />
        </CloseButton>
        <InstructionsContainer id={HANDLE_ID}>
          <InstructionsContent>
            <Title>{texts.title}</Title>
            <Text>{ReactHtmlParser(texts.instructions)}</Text>
          </InstructionsContent>
        </InstructionsContainer>
      </StyledPopper>
    </Draggable>
  );
};

WorkoutGenInstructions.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default WorkoutGenInstructions;
